<template>
  <div class="ORight">
    <div class="Ozg">Применение</div>
    <div class="Oplus" v-for="(useit, index) in card.useit">{{ useit }}<div class="TrashBt" v-if="showEditLink" @click="deleteUse(index)"></div></div>
    <!-- <div class="Oplus">Зафиксировать результаты<div class="TrashBt"></div></div> -->
    <div class="Oadd" v-if="showEditLink"><input type="email" class="Oinput" name="Login" placeholder="Добавить..." v-model="newUse"><div class="AddBt" @click="saveUse"></div></div>
  </div>
</template>

<script>
import { pick } from 'lodash';

export default {
  props: {
    card: { type: Object, default: function() { return {}; } },
    showEditLink: { type: Boolean, default: function() { return false; } },
    saveData: Function
  },
  data() {
    return {
      newUse: "",
    };
  },
  methods: {
    saveUse() {
      console.log('saveUse', this.newUse);
      if (!this.newUse) return;

      const useit = this.card.useit.concat([this.newUse]);
      const params = {useit: useit};
      console.log('updateCardColumns params', params);

      this.saveData({card: params}, false, ['useit']);
      this.newUse = "";
    },
    deleteUse(index) {
      const useit = this.card.useit;
      useit.splice(index, 1);
      console.log('deleteLink', useit);
      const params = {useit: useit};
      this.saveData({card: params}, false, ['useit']);
    },
  }
};
</script>
